module.exports = __webpack_public_path__ + "static/media/Vlada-1.676145b4.jpg";